import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CourseInfoLisActions, CourseInfoLisSelector } from "shared/reducers/CourseInfoListSlice";
import styled from "styled-components";

const Wrap = styled.div`
    margin-right: 18px;
`;

const ListIcon: FC<{ onClick: () => void }> = ({ onClick }) => (
    <svg onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.75459 5.77758C7.75459 5.45867 8.0209 5.18869 8.36369 5.18869H21.091C21.4337 5.18869 21.7001 5.45867 21.7001 5.77758C21.7001 6.0965 21.4337 6.36647 21.091 6.36647H8.36369C8.0209 6.36647 7.75459 6.0965 7.75459 5.77758ZM7.75459 11.9998C7.75459 11.6809 8.0209 11.4109 8.36369 11.4109H21.091C21.4337 11.4109 21.7001 11.6809 21.7001 11.9998C21.7001 12.3187 21.4337 12.5887 21.091 12.5887H8.36369C8.0209 12.5887 7.75459 12.3187 7.75459 11.9998ZM7.75459 18.222C7.75459 17.9031 8.0209 17.6331 8.36369 17.6331H21.091C21.4337 17.6331 21.7001 17.9031 21.7001 18.222C21.7001 18.5409 21.4337 18.8109 21.091 18.8109H8.36369C8.0209 18.8109 7.75459 18.5409 7.75459 18.222ZM5.33641 5.77758C5.33641 6.58742 4.66309 7.25536 3.81823 7.25536C2.97337 7.25536 2.30005 6.58742 2.30005 5.77758C2.30005 4.96775 2.97337 4.2998 3.81823 4.2998C4.66309 4.2998 5.33641 4.96775 5.33641 5.77758ZM5.33641 11.9998C5.33641 12.8096 4.66309 13.4776 3.81823 13.4776C2.97337 13.4776 2.30005 12.8096 2.30005 11.9998C2.30005 11.19 2.97337 10.522 3.81823 10.522C4.66309 10.522 5.33641 11.19 5.33641 11.9998ZM5.33641 18.222C5.33641 19.0319 4.66309 19.6998 3.81823 19.6998C2.97337 19.6998 2.30005 19.0319 2.30005 18.222C2.30005 17.4122 2.97337 16.7442 3.81823 16.7442C4.66309 16.7442 5.33641 17.4122 5.33641 18.222Z" fill="#909090"/>
    </svg>
)

export const CourseInfoListController: FC = () => {
    const dispatch = useDispatch();
    const state = useSelector(CourseInfoLisSelector)?.courseInfoVisibile;
    const itemCount = useSelector(CourseInfoLisSelector)?.itemCount;

    const visible = useMemo(() => (!!itemCount) , [itemCount])

    const toggleVisible = () => dispatch(CourseInfoLisActions.toggle(!state))

    if (!visible) {
        return null;
    }

    return (
        <Wrap>
            <ListIcon onClick={toggleVisible} />
        </Wrap>
    )
}import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CourseInfoLisActions, CourseInfoLisSelector } from "shared/reducers/CourseInfoListSlice";
import styled from "styled-components";

const Wrap = styled.div`
    margin-right: 18px;
`;

const ListIcon: FC<{ onClick: () => void }> = ({ onClick }) => (
    <svg onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.75459 5.77758C7.75459 5.45867 8.0209 5.18869 8.36369 5.18869H21.091C21.4337 5.18869 21.7001 5.45867 21.7001 5.77758C21.7001 6.0965 21.4337 6.36647 21.091 6.36647H8.36369C8.0209 6.36647 7.75459 6.0965 7.75459 5.77758ZM7.75459 11.9998C7.75459 11.6809 8.0209 11.4109 8.36369 11.4109H21.091C21.4337 11.4109 21.7001 11.6809 21.7001 11.9998C21.7001 12.3187 21.4337 12.5887 21.091 12.5887H8.36369C8.0209 12.5887 7.75459 12.3187 7.75459 11.9998ZM7.75459 18.222C7.75459 17.9031 8.0209 17.6331 8.36369 17.6331H21.091C21.4337 17.6331 21.7001 17.9031 21.7001 18.222C21.7001 18.5409 21.4337 18.8109 21.091 18.8109H8.36369C8.0209 18.8109 7.75459 18.5409 7.75459 18.222ZM5.33641 5.77758C5.33641 6.58742 4.66309 7.25536 3.81823 7.25536C2.97337 7.25536 2.30005 6.58742 2.30005 5.77758C2.30005 4.96775 2.97337 4.2998 3.81823 4.2998C4.66309 4.2998 5.33641 4.96775 5.33641 5.77758ZM5.33641 11.9998C5.33641 12.8096 4.66309 13.4776 3.81823 13.4776C2.97337 13.4776 2.30005 12.8096 2.30005 11.9998C2.30005 11.19 2.97337 10.522 3.81823 10.522C4.66309 10.522 5.33641 11.19 5.33641 11.9998ZM5.33641 18.222C5.33641 19.0319 4.66309 19.6998 3.81823 19.6998C2.97337 19.6998 2.30005 19.0319 2.30005 18.222C2.30005 17.4122 2.97337 16.7442 3.81823 16.7442C4.66309 16.7442 5.33641 17.4122 5.33641 18.222Z" fill="#909090"/>
    </svg>
)

export const CourseInfoListController: FC = () => {
    const dispatch = useDispatch();
    const state = useSelector(CourseInfoLisSelector)?.courseInfoVisibile;
    const itemCount = useSelector(CourseInfoLisSelector)?.itemCount;

    const visible = useMemo(() => (!!itemCount) , [itemCount])

    const toggleVisible = () => dispatch(CourseInfoLisActions.toggle(!state))

    if (!visible) {
        return null;
    }

    return (
        <Wrap>
            <ListIcon onClick={toggleVisible} />
        </Wrap>
    )
}